import { HttpStatusCode } from './http-status-code';

export const statusCodeToHttpStatusCode: Record<string, HttpStatusCode> = {
  '202': HttpStatusCode.ACCEPTED,
  '502': HttpStatusCode.BAD_GATEWAY,
  '400': HttpStatusCode.BAD_REQUEST,
  '409': HttpStatusCode.CONFLICT,
  '100': HttpStatusCode.CONTINUE,
  '201': HttpStatusCode.CREATED,
  '417': HttpStatusCode.EXPECTATION_FAILED,
  '424': HttpStatusCode.FAILED_DEPENDENCY,
  '403': HttpStatusCode.FORBIDDEN,
  '504': HttpStatusCode.GATEWAY_TIMEOUT,
  '410': HttpStatusCode.GONE,
  '505': HttpStatusCode.HTTP_VERSION_NOT_SUPPORTED,
  '418': HttpStatusCode.IM_A_TEAPOT,
  '419': HttpStatusCode.INSUFFICIENT_SPACE_ON_RESOURCE,
  '507': HttpStatusCode.INSUFFICIENT_STORAGE,
  '500': HttpStatusCode.INTERNAL_SERVER_ERROR,
  '411': HttpStatusCode.LENGTH_REQUIRED,
  '423': HttpStatusCode.LOCKED,
  '420': HttpStatusCode.METHOD_FAILURE,
  '405': HttpStatusCode.METHOD_NOT_ALLOWED,
  '301': HttpStatusCode.MOVED_PERMANENTLY,
  '302': HttpStatusCode.MOVED_TEMPORARILY,
  '207': HttpStatusCode.MULTI_STATUS,
  '300': HttpStatusCode.MULTIPLE_CHOICES,
  '511': HttpStatusCode.NETWORK_AUTHENTICATION_REQUIRED,
  '204': HttpStatusCode.NO_CONTENT,
  '203': HttpStatusCode.NON_AUTHORITATIVE_INFORMATION,
  '406': HttpStatusCode.NOT_ACCEPTABLE,
  '404': HttpStatusCode.NOT_FOUND,
  '501': HttpStatusCode.NOT_IMPLEMENTED,
  '304': HttpStatusCode.NOT_MODIFIED,
  '200': HttpStatusCode.OK,
  '206': HttpStatusCode.PARTIAL_CONTENT,
  '402': HttpStatusCode.PAYMENT_REQUIRED,
  '308': HttpStatusCode.PERMANENT_REDIRECT,
  '412': HttpStatusCode.PRECONDITION_FAILED,
  '428': HttpStatusCode.PRECONDITION_REQUIRED,
  '102': HttpStatusCode.PROCESSING,
  '407': HttpStatusCode.PROXY_AUTHENTICATION_REQUIRED,
  '431': HttpStatusCode.REQUEST_HEADER_FIELDS_TOO_LARGE,
  '408': HttpStatusCode.REQUEST_TIMEOUT,
  '413': HttpStatusCode.REQUEST_TOO_LONG,
  '414': HttpStatusCode.REQUEST_URI_TOO_LONG,
  '416': HttpStatusCode.REQUESTED_RANGE_NOT_SATISFIABLE,
  '205': HttpStatusCode.RESET_CONTENT,
  '303': HttpStatusCode.SEE_OTHER,
  '503': HttpStatusCode.SERVICE_UNAVAILABLE,
  '101': HttpStatusCode.SWITCHING_PROTOCOLS,
  '307': HttpStatusCode.TEMPORARY_REDIRECT,
  '429': HttpStatusCode.TOO_MANY_REQUESTS,
  '401': HttpStatusCode.UNAUTHORIZED,
  '451': HttpStatusCode.UNAVAILABLE_FOR_LEGAL_REASONS,
  '422': HttpStatusCode.UNPROCESSABLE_ENTITY,
  '415': HttpStatusCode.UNSUPPORTED_MEDIA_TYPE,
  '305': HttpStatusCode.USE_PROXY,
  '421': HttpStatusCode.MISDIRECTED_REQUEST,
};
